import { createFileRoute } from '@tanstack/react-router';

import { ConsentimientosPage } from '@/features/compliance/components/consentimientos-page';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';

export const Route = createFileRoute('/_app/compliance/consentimientos')({
  component: ComplianceConsentimientosRoute,
});

function ComplianceConsentimientosRoute() {
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <ConsentimientosPage />
    </div>
  );
}
